<template>
    <div class="main_box">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>基本信息管理</el-breadcrumb-item>
            <el-breadcrumb-item>登录日记</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="content">
            <el-form class="form" :model="form" :inline="true" size="small" ref="form">
                <el-form-item label="用户名称" prop="param.username">
                    <el-input v-model="form.param.username"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="param.mobile">
                    <el-input v-model="form.param.mobile"></el-input>
                </el-form-item>
                <!-- <el-form-item label="邮箱" prop="param.email">
                    <el-input v-model="form.param.email"></el-input>
                </el-form-item>-->
                <el-form-item>
                    <el-button type="primary" @click="query">搜索</el-button>
                    <el-button @click="$refs.form.resetFields()">清空</el-button>
                </el-form-item>
            </el-form>
            <el-table class="table" :data="data" border>
                <el-table-column label="序号" type="index" width="50px"></el-table-column>
                <el-table-column label="用户名" prop="username"></el-table-column>
                <el-table-column label="手机号" prop="account"></el-table-column>
                <!-- <el-table-column label="邮箱" prop="email"></el-table-column> -->
                <el-table-column label="登录IP" prop="ip"></el-table-column>
                <el-table-column label="系统" prop="app"></el-table-column>
                <el-table-column label="登录时间" prop="loginTime" width="160px">
                    <template
                        slot-scope="scope"
                    >{{scope.row.loginTime | formatTime('yyyy-MM-dd hh:mm:ss')}}</template>
                </el-table-column>
                <el-table-column label="退出时间" prop="logoutTime">
                    <template
                        slot-scope="scope"
                    >{{scope.row.logoutTime | formatTime('yyyy-MM-dd hh:mm:ss')}}</template>
                </el-table-column>
            </el-table>
            <gl-page
                @size-change="sizeChange"
                @current-change="query"
                :current-page="form.pageNum"
                :page-size="form.pageSize"
                :total="total"
            ></gl-page>
        </div>
    </div>
</template>
<script>
import glPage from '../../components/glPage'
export default {
    components: {
        glPage
    },
    data() {
        return {
            form: {
                pageNum: 1,
                pageSize: 10,
                param: {
                    username: '',
                    mobile: '',
                    email: '',
                },
            },
            data: [],
            total: 0,
        }
    },
    mounted() {
        this.query();
    },
    methods: {
        query(a) {
            if (isNaN(a)) {
                a = 1
            }
            this.form.pageNum = a
            this.ajax.post('/login_log/admin/getLoginLogPageList', this.form).then(data => {
                this.data = data.list
                this.total = data.total
            })
        },
        sizeChange(a) {
            this.form.pageSize = a
            this.query()
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/page/superAdmin/handleDiary.vue